import { Scrollbox } from 'pixi-scrollbox';
import { PixiBase } from '../../core/pixi/PixiBase';
import { setTranslationValues } from '../../core/helpers';
import { payTableListMobile, payTableListWeb } from '../../core/constants/payTableList';

import { gameStore } from '../../store/gameStore';
import { betBarStore } from '../../store/betBarStore';
import { menuBarStore } from '../../store/menuBarStore';
import { spinBarStore } from '../../store/spinBarStore';
import { userInfoStore } from '../../store/userInfoStore';
import { introBarStore } from '../../store/introBarStore';
import { applicationStore } from '../../store/applicationStore';
import { userSettingsStore } from '../../store/userSettingsStore';

import { isMobile } from '../../helpers/isMobile';
import { setContainersPosition } from '../../helpers';
import { isoStandard } from '../../helpers/isoStandard';
import { betButtonStates } from '../../helpers/betButtonStates';
import { getPayTableSteps } from '../../helpers/getPayTableSteps';
import { parseNumberByPrecision } from '../../helpers/parseNumberByPrecision';
import { betButtonContainerXPositionHandler } from '../../helpers/betButtonContainerXPositionHandler';

import { gameMainDrawer } from './gameMainDrawer';
import { containerNames, frameNames } from '../../constants';
import { animationService } from '../../services/animationService';
import { GameRulesKeys, JACKPOT_RULES } from '../../enums/gameRules';
import { boostedJackpotStore } from '../../store/boostedJackpotStore';

export class IntroBarDrawer {
  constructor() {
    this.animations = {};
    this.stepsCount = 0;
    this.rounds = [];
    this.settingsButtonsAmount = {};
    this.IntroBarContainer = PixiBase.createContainer(containerNames.IntroBarContainer);
    this.gameRulesContainer = PixiBase.createContainer(containerNames.GameRulesContainer);
    this.settingsBarContainer = PixiBase.createContainer(containerNames.SettingsBarContainer);
    this.payTableBarContainer = PixiBase.createContainer(containerNames.PayTableBarContainer);
    this.payTableArrowContainer = PixiBase.createContainer(containerNames.PayTableArrowContainer);
    this.payTableContainersWrapper = PixiBase.createContainer(
      containerNames.PayTableContainersWrapper
    );
    this.payTableContainersWrapper.visible = false;
    this.payTableContainersWrapper.addChild(this.payTableBarContainer);
    this.setupSliderEventsGraphics();
    this.payTableContainersWrapper.addChild(this.payTableArrowContainer);
    this.IntroBarContainer.addChild(this.payTableContainersWrapper);
    this.IntroBarContainer.addChild(this.settingsBarContainer);
    this.IntroBarContainer.addChild(this.gameRulesContainer);

    this.containersByName = {
      payTableContainersWrapper: this.payTableContainersWrapper,
      gameRulesContainer: this.gameRulesContainer,
      settingsBarContainer: this.settingsBarContainer,
    };
    this.symbolCountByIndex = { 0: 5, 1: 4, 2: 3, 3: 2 };
    this.isButtonPressed = false;
    this.isSlideAnimationOn = false;
    isMobile() && (this.settingsBarContainer.y = -55);
  }

  updateSettingsBarButtonsAmountState(amount) {
    Object.keys(this.settingsButtonsAmount).forEach((el) => {
      if (+el === amount) {
        PixiBase.changeFrame(this.settingsButtonsAmount[el], frameNames.SelectedQuickBetState);
      } else {
        PixiBase.changeFrame(this.settingsButtonsAmount[el], frameNames.NormalBetButtonState);
      }
    });
  }

  switchPage({ direction }) {
    this.isSlideAnimationOn = true;
    PixiBase.changeFrame(this.rounds[this.stepsCount], 'paytableDisableRound');
    const { children: payTableStepContainers, x } = this.payTableBarContainer;
    const maxWidth = -(payTableStepContainers.length - 1) * payTableStepContainers[0].width;
    this.stepsCount =
      (this.stepsCount + payTableStepContainers.length + direction) % payTableStepContainers.length;

    if (x < maxWidth) {
      this.stepsCount = payTableStepContainers.length - 1;
      this.move = -payTableStepContainers[payTableStepContainers.length - 1].x;
    } else if (x > payTableStepContainers[0].x) {
      this.stepsCount = 0;
      this.move = -payTableStepContainers[0].x;
    } else {
      this.move = -payTableStepContainers[this.stepsCount].x;
    }

    animationService.animateWithGsap({
      container: this.payTableBarContainer,
      x: this.move,
      onComplete: () => {
        this.isButtonPressed = false;
        this.isSlideAnimationOn = false;
      },
      duration: isMobile() ? 0.15 : 0.2,
    });
    PixiBase.changeFrame(this.rounds[this.stepsCount], 'paytableActiveRound');
  }

  setupArrowButtons() {
    const playButtonContainer = PixiBase.createContainer('playButtonContainer');
    const { x, y } = this.config.IntroBarContainer.payTableArrowContainer;
    PixiBase.setPosition(this.payTableArrowContainer, { x: x, y: y });
    this.arrowLeft = PixiBase.createSprite(this.spriteSheet.paytablearrowLeft);
    this.arrowRight = PixiBase.createSprite(this.spriteSheet.paytablearrowRight);
    this.playButton = PixiBase.createSprite(this.spriteSheet.paytablePlay);
    this.arrowRight.x = isMobile() ? 244 : 245;
    const arrayRightY = 13;
    this.arrowRight.y = arrayRightY;
    this.arrowLeft.y = arrayRightY;
    this.arrowLeft.x = isMobile() ? 13 : 10;
    this.playButton.x = 55;
    this.playButtonTitle = PixiBase.createText(gameStore.canvasTranslationKeys.PLAY, {
      fontSize: 24,
      fill: '#212121',
      align: 'center',
      fontWeight: 600,
      fontFamily: 'Roboto',
    });
    this.playButtonTitle.y = 13;
    this.payTableArrowContainer.addChild(this.arrowLeft);
    this.payTableArrowContainer.addChild(this.arrowRight);
    playButtonContainer.addChild(this.playButton);
    playButtonContainer.addChild(this.playButtonTitle);
    this.payTableArrowContainer.addChild(playButtonContainer);
    this.playButtonTitle.anchor.x = 0.5;
    this.playButtonTitle.x = Math.ceil(this.playButton.x + this.playButton.width / 2);
    PixiBase.setupButtonMode(this.arrowRight, { interactive: true, buttonMode: true });
    PixiBase.setupButtonMode(this.arrowLeft, { interactive: true, buttonMode: true });
    PixiBase.setupButtonMode(playButtonContainer, { interactive: true, buttonMode: true });

    PixiBase.registerClick(this.arrowRight, (e) => {
      if (this.isSlideAnimationOn) return;

      PixiBase.changeFrame(e.target, frameNames.PaytablearrowRightPressed);
      this.payTableBarContainer.x ===
      -(this.payTableBarContainer.children.length - 1) * (isMobile() ? 540 : 1170)
        ? (this.isButtonPressed = false)
        : (this.isButtonPressed = true);
    });
    PixiBase.registerPointerover(this.arrowRight, (e) => {
      if (!isMobile()) PixiBase.changeFrame(e.target, frameNames.PaytablearrowRightHover);
    });
    PixiBase.registerPointerout(this.arrowRight, (e) => {
      PixiBase.changeFrame(e.target, frameNames.PaytablearrowRight);
    });
    PixiBase.registerPointerup(this.arrowRight, (e) => {
      PixiBase.changeFrame(e.target, frameNames.PaytablearrowRight);
      if (this.isButtonPressed) {
        this.switchPage({ direction: 1 });
      }
      this.isButtonPressed = false;
    });
    PixiBase.registerPointerUpOutside(this.arrowRight, (e) => {
      PixiBase.changeFrame(e.target, frameNames.PaytablearrowRight);
      this.isButtonPressed = false;
    });

    PixiBase.registerClick(this.arrowLeft, (e) => {
      if (this.isSlideAnimationOn) return;

      PixiBase.changeFrame(e.target, frameNames.PaytablearrowLeftPressed);
      this.payTableBarContainer.x === this.payTableBarContainer.children[0].x
        ? (this.isButtonPressed = false)
        : (this.isButtonPressed = true);
    });
    PixiBase.registerPointerover(this.arrowLeft, (e) => {
      if (!isMobile()) PixiBase.changeFrame(e.target, frameNames.PaytablearrowLeftHover);
    });

    PixiBase.registerPointerout(this.arrowLeft, (e) => {
      PixiBase.changeFrame(e.target, frameNames.PaytablearrowLeft);
    });

    PixiBase.registerPointerup(this.arrowLeft, (e) => {
      PixiBase.changeFrame(e.target, frameNames.PaytablearrowLeft);
      if (this.isButtonPressed) {
        this.switchPage({ direction: -1 });
      }
      this.isButtonPressed = false;
    });
    PixiBase.registerPointerUpOutside(this.arrowLeft, (e) => {
      PixiBase.changeFrame(e.target, frameNames.PaytablearrowLeft);
      this.isButtonPressed = false;
    });

    PixiBase.registerClick(playButtonContainer, () => {
      PixiBase.changeFrame(this.playButton, frameNames.PaytablePlayPressing);
      this.isButtonPressed = true;
    });

    PixiBase.registerPointerover(playButtonContainer, () => {
      if (!isMobile()) PixiBase.changeFrame(this.playButton, frameNames.PaytablePlayHover);
    });

    PixiBase.registerPointerup(playButtonContainer, () => {
      const freeBetCount = gameStore.tournamentInfoInitial?.freeBetCount
        ? gameStore.tournamentInfoInitial?.freeBetCount
        : spinBarStore.freeBetList[spinBarStore.activeFreeBetIndex]?.remainingCount;
      if (this.isButtonPressed) {
        gameMainDrawer.freeBetBar.toggleVisibilityFreeBetCountContainer(
          menuBarStore.isMenuPopupOpen && Boolean(freeBetCount)
        );
        applicationStore.setIsShowJackpot(applicationStore.hasJackPot);
        gameMainDrawer.boostedJackpot.BoostedJackpotContainer.visible = Boolean(
          boostedJackpotStore.isBoostedJackpot
        );
        this.handlePlayButtonFunctional();
        gameMainDrawer.menuBar.menuWrapperShadow.visible = true;
      }
      this.isButtonPressed = false;
    });

    PixiBase.registerPointerout(playButtonContainer, () => {
      PixiBase.changeFrame(this.playButton, frameNames.PaytablePlay);
    });
    PixiBase.registerPointerUpOutside(playButtonContainer, () => {
      PixiBase.changeFrame(this.playButton, frameNames.PaytablePlay);
    });
  }

  setupSlideStepRounds() {
    const disableRoundCount = applicationStore.hasJackPot ? 5 : 4;
    for (let i = 0; i < disableRoundCount; i += 1) {
      const round = PixiBase.createSprite(this.spriteSheet.paytableDisableRound);
      const xPosition = disableRoundCount === 4 ? 105 : 95;
      round.x = xPosition + i * (round.height + round.width);
      round.y = 70;
      if (i === 0) {
        PixiBase.changeFrame(round, 'paytableActiveRound');
      }
      this.rounds.push(round);
      this.payTableArrowContainer.addChild(round);
    }
  }

  handlePlayButtonFunctional() {
    gameMainDrawer.menuBar.menuBarPopupContainer.visible = false;
    this.handleVisibilityContainersByName(containerNames.PayTableContainersWrapper);
    gameMainDrawer.menuBar.visible = !menuBarStore.isMenuPopupOpen;
    if (menuBarStore.isMenuPopupOpen) {
      this.handleVisibilityContainersByName();
      if (isMobile()) {
        gameMainDrawer.menuBar.menuBarWrapperContainer.visible = true;
        gameMainDrawer.menuBar.isShowMobileIntroView(false);
        setTimeout(() => {
          gameMainDrawer.boostedJackpot.BoostedJackpotContainer.visible = Boolean(
            boostedJackpotStore.isBoostedJackpot
          );
          applicationStore.setIsShowJackpot(applicationStore.hasJackPot);
        }, 50);
      }
    }
    menuBarStore.menuPopupToggle();
    gameMainDrawer.menuBar.setIntroBarVisibleState();
    const closeMenuBarIcon = isMobile()
      ? frameNames.CloseMenuBarIconMobile
      : frameNames.CloseMenuBarIcon;

    const openMenuBarIcon = isMobile()
      ? frameNames.OpenMenuBarIconMobile
      : frameNames.OpenMenuBarIcon;

    PixiBase.changeFrame(
      gameMainDrawer.menuBar.openMenuIcon,
      menuBarStore.isMenuPopupOpen ? closeMenuBarIcon : openMenuBarIcon
    );
  }

  updatePayTableOddInfo() {
    this.payTableOddAndAmountInfo.children = [];
    const { selectedAmount } = betBarStore;
    const { oddsInfo } = gameStore;
    (isMobile() ? payTableListMobile : payTableListWeb).forEach((el) => {
      this.createLine(el, oddsInfo[el.id - 1], selectedAmount);
    });
  }

  createLine({ countX, countY, oddX, oddY }, oddInfo, selectedAmount) {
    const textWrapper = PixiBase.createContainer('');
    oddInfo.forEach((odd, index) => {
      if (odd) {
        const count = PixiBase.createText(`${this.symbolCountByIndex[index]} x`, {
          fontSize: isMobile() ? 13 : 17,
          fill: 'white',
          align: 'center',
          fontWeight: 510,
          fontFamily: 'Roboto',
        });
        PixiBase.setPosition(count, { x: countX, y: countY + index * (isMobile() ? 14 : 20) });
        const multiplier = PixiBase.createText(
          `${isoStandard(parseNumberByPrecision(odd, selectedAmount, userInfoStore.precision))}`,
          {
            fontSize: isMobile() ? 13 : 17,
            fill: '#FFC33E',
            align: 'center',
            fontWeight: 510,
            fontFamily: 'Roboto',
          }
        );
        PixiBase.setPosition(multiplier, { x: oddX, y: oddY + index * (isMobile() ? 14 : 20) });
        textWrapper.addChild(count);
        textWrapper.addChild(multiplier);
      }
    });
    this.payTableOddAndAmountInfo.addChild(textWrapper);
  }

  setupPayTableSteps() {
    (applicationStore.hasJackPot ? getPayTableSteps() : getPayTableSteps().slice(0, -1)).forEach(
      ({ images, texts, stepNumber }) => {
        const payTableStepContainer = PixiBase.createContainer(
          `${containerNames.PayTableStepsContainer}${stepNumber + 1}`
        );
        images.forEach(({ value, x, y }) => {
          const payTableImage = PixiBase.createSprite(value);
          payTableImage.anchor.set(0);
          PixiBase.setPosition(payTableImage, { x, y });
          payTableStepContainer.addChild(payTableImage);
        });

        this.textContent = PixiBase.createContainer(containerNames.TextContent);
        texts.forEach(({ value, x, y, weight, fontSize, wordWrapWidth }) => {
          const payTableText = PixiBase.createText(value, {
            weight,
            fontSize,
            align: 'center',
            fill: '#FFFFFF',
            fontFamily: 'Roboto',
            wordWrap: true,
            wordWrapWidth,
          });
          PixiBase.setPosition(payTableText, { x, y });
          payTableText.anchor.x = 0.5;
          this.textContent.addChild(payTableText);
          payTableStepContainer.addChild(this.textContent);
        });

        if (texts.length > 1) {
          this.payTableOddAndAmountInfo = PixiBase.createContainer(
            containerNames.PayTableOddAndAmountInfo
          );
          const { x, y } = this.config.IntroBarContainer.payTableOddAndAmountInfoConfig;
          PixiBase.setPosition(this.payTableOddAndAmountInfo, { x: x, y: y });
          payTableStepContainer.addChild(this.payTableOddAndAmountInfo);
        }
        this.payTableBarContainer.addChild(payTableStepContainer);
        this.payTableStepContainer = payTableStepContainer;
      }
    );
    this.handlePayTableStepsPosition();
  }

  handlePayTableStepsPosition() {
    this.payTableBarContainer.children.forEach((stepContainer, index) => {
      stepContainer.x = index * (isMobile() ? 540 : 1170);
    });
  }

  setupSettingsHeader() {
    this.settingsBarContainer.visible = false;
    this.settingsHeaderContainer = PixiBase.createContainer(containerNames.SettingsHeaderContainer);
    const { x, y } = this.config.IntroBarContainer.settingsHeaderContainerConfig;
    PixiBase.setPosition(this.settingsHeaderContainer, { x: x, y: y });
    this.settingsBarContainer.addChild(this.settingsHeaderContainer);
  }

  setupSettingsTitle() {
    this.settingsTitle = PixiBase.createText(gameStore.canvasTranslationKeys.SETTINGS, {
      fontSize: 35,
      fill: 'white',
      align: 'center',
      fontWeight: 510,
      fontFamily: 'Roboto',
    });
    const { x, y, anchor } = this.config.IntroBarContainer.settingsTitleConfig;
    PixiBase.setPosition(this.settingsTitle, { x: x, y: y });
    this.settingsTitle.anchor.set(anchor);
    this.settingsHeaderContainer.addChild(this.settingsTitle);
  }

  setupSoundSettings() {
    this.soundSettingsContainer = PixiBase.createContainer(containerNames.SoundSettingsContainer);
    const { x, y } = this.config.IntroBarContainer.soundSettingsContainerConfig;
    PixiBase.setPosition(this.soundSettingsContainer, { x: x, y: y });
    const soundAndMusicText = [
      { text: gameStore.canvasTranslationKeys.SOUNDS_EFFECTS, isSound: true },
    ];
    soundAndMusicText.forEach(({ text, isSound }, i) => {
      this.soundText = PixiBase.createText(text, {
        fontSize: 20,
        fill: 'white',
        align: 'center',
        fontWeight: 510,
        fontFamily: 'Roboto',
      });
      const switcher = PixiBase.createSprite(this.spriteSheet.switchOn);
      const divisionLine = PixiBase.createSprite(this.spriteSheet.divisionLine);
      const { y: textY } = this.config.IntroBarContainer.soundTextConfig;
      // eslint-disable-next-line no-shadow
      const { x, y } = this.config.IntroBarContainer.switcherConfig;
      const { y: lineY } = this.config.IntroBarContainer.divisionLineConfig;
      PixiBase.setPosition(divisionLine, { y: i * lineY });
      PixiBase.setPosition(this.soundText, { y: i * textY - 35 });
      PixiBase.setPosition(switcher, { x: x, y: i * y - 45 });
      PixiBase.setupButtonMode(switcher, { interactive: true, buttonMode: true });
      PixiBase.registerClick(switcher, () => {
        if (isSound) {
          userSettingsStore.setIsSoundOn();
        } else {
          userSettingsStore.setIsMusicOn();
        }
        introBarStore.switcherToggle();
        const switcherValue = isSound ? userSettingsStore.isSoundOn : userSettingsStore.isMusicOn;
        PixiBase.changeFrame(switcher, switcherValue ? frameNames.SwitchOn : frameNames.SwitchOff);
      });
      this.soundSettingsContainer.addChild(this.soundText);
      this.soundSettingsContainer.addChild(switcher);
      this.soundSettingsContainer.addChild(divisionLine);
    });
    this.settingsHeaderContainer.addChild(this.soundSettingsContainer);
  }

  setupSettingsButtonsTitle() {
    this.buttonsTitle = PixiBase.createText(gameStore.canvasTranslationKeys.QUICK_BETS, {
      fontSize: 35,
      fill: 'white',
      align: 'center',
      fontWeight: 510,
      fontFamily: 'Roboto',
    });
    const { y } = this.config.IntroBarContainer.buttonsTitleConfig;

    PixiBase.setPosition(this.buttonsTitle, {
      x:
        (this.settingsButtonsContainer.width -
          this.buttonsTitle.width -
          this.settingsButtonWrapper.width) /
        2,
      y: y,
    });
    this.settingsButtonsContainer.addChild(this.buttonsTitle);
  }

  setupSettingsButtons() {
    const { currencySymbolOrCode } = userInfoStore;
    this.settingsButtonsContainer = PixiBase.createContainer(
      containerNames.SettingsButtonsContainer
    );
    const { x, y } = this.config.IntroBarContainer.settingsButtonsContainer;
    PixiBase.setPosition(this.settingsButtonsContainer, { x, y });
    const spacing = 5;
    const rowCapacity = 4;
    betBarStore.quickBetArr.forEach((item, index) => {
      const settingsButtonWrapper = PixiBase.createContainer('settingsButtonWrapper');
      this.settingsButtonWrapper = settingsButtonWrapper;
      const settingsButton = PixiBase.createSprite(this.spriteSheet.normalBetButtonState);
      !index && PixiBase.changeFrame(settingsButton, frameNames.SelectedQuickBetState);
      this.settingsButtonsAmount[item] = settingsButton;
      settingsButton.amountValue = item;
      settingsButtonWrapper.amountValue = item;

      const currency = PixiBase.createText(currencySymbolOrCode, {
        fontSize: 15,
        fill: 'white',
        align: 'center',
        fontWeight: 600,
        fontFamily: 'Roboto',
      });
      const betAmount = PixiBase.createText(isoStandard(item), {
        fontSize: 23,
        fill: 'white',
        align: 'center',
        fontWeight: 600,
        fontFamily: 'Roboto',
      });

      this.buttonWidth = settingsButton.width;
      this.buttonHeight = settingsButton.height;
      const row = Math.floor(index / rowCapacity);
      const col = index % rowCapacity;
      const buttonX = Math.ceil(col * (settingsButton.width + spacing));
      const buttonY = Math.ceil(row * (settingsButton.height + spacing));
      PixiBase.setPosition(settingsButton, { x: buttonX, y: buttonY });
      PixiBase.setPosition(betAmount, { x: buttonX, y: buttonY + 5 });
      PixiBase.setPosition(currency, { x: buttonX, y: buttonY - 15 });
      settingsButton.anchor.set(0.5);
      betAmount.anchor.set(0.5);
      currency.anchor.set(0.5);
      settingsButtonWrapper.addChild(settingsButton);
      settingsButtonWrapper.addChild(betAmount);
      settingsButtonWrapper.addChild(currency);
      this.settingsButtonsContainer.addChild(settingsButtonWrapper);
      PixiBase.setupButtonMode(settingsButtonWrapper, { interactive: true, buttonMode: true });
      PixiBase.registerClick(settingsButtonWrapper, () =>
        betButtonContainerXPositionHandler(index)
      );
      betButtonStates(settingsButtonWrapper, true);
    });

    this.settingsBarContainer.addChild(this.settingsButtonsContainer);
    this.setupSettingsButtonsTitle();
  }

  setupGameRules() {
    this.gameRulesContainer.visible = false;
    const gameRulesGraphics = PixiBase.createGraphics();
    gameRulesGraphics.beginFill('black');
    gameRulesGraphics.alpha = 0.3;
    gameRulesGraphics.drawRect(
      isMobile() ? 0 : 85,
      isMobile() ? 210 : 0,
      isMobile() ? 600 : 1000,
      isMobile() ? 650 : 810
    );
    gameRulesGraphics.endFill();
    this.gameRulesContainer.addChild(gameRulesGraphics);

    const scrollBox = new Scrollbox({
      boxWidth: isMobile() ? 600 : 900,
      boxHeight: isMobile() ? 640 : 810,
      overflow: 'hidden',
    });
    this.scrollBox = scrollBox;
    this.scrollBox.x = isMobile() ? 20 : 145;
    this.scrollBox.y = isMobile() ? 210 : 0;
    PixiBase.setupButtonMode(this.gameRulesContainer, { interactive: true, buttonMode: true });

    let start = 0;
    [...GameRulesKeys, ...(applicationStore.hasJackPot ? JACKPOT_RULES : [])].forEach(
      ({ key, type, valueKey, isCircle }) => {
        const rulesItemContainer = PixiBase.createContainer('rulesItemContainer');
        const textValue = setTranslationValues(gameStore.canvasTranslationKeys[key], {
          VALUE: isoStandard(betBarStore.limits[valueKey]),
        });
        const text = PixiBase.createText(textValue, {
          fontSize: type === 'title' ? 25 : 18,
          fill: type === 'title' ? '#FFD880' : '#FFFFFF',
          align: 'left',
          wordWrap: true,
          wordWrapWidth: isMobile() ? 510 : 900,
          fontWeight: type === 'title' ? 700 : 500,
          fontFamily: 'Roboto',
        });
        if (isCircle) {
          const circle = PixiBase.createSprite(this.spriteSheet.circle);
          circle.scale.set(0.7);
          circle.anchor.set(0);
          PixiBase.setPosition(circle, { y: Math.ceil(start + 5), x: 0 });
          rulesItemContainer.addChild(circle);
        }
        PixiBase.setPosition(text, {
          y: Math.ceil(start),
          x: isCircle ? 20 : 0,
        });
        rulesItemContainer.addChild(text);
        this.scrolledContainer = this.scrollBox.content.addChild(rulesItemContainer);
        start = isMobile() ? text.y + text.height + 10 : text.y + text.height + 20;
        this.gameRulesContainer.addChild(this.scrollBox);
      }
    );
  }

  handleVisibilityContainersByName(containerName = '') {
    Object.keys(this.containersByName).forEach((name) => {
      this.containersByName[name].visible = containerName === name;
    });
  }

  onHandleDragMove(event) {
    if (gameMainDrawer.betBar.isDragging) {
      if (Math.abs(event.data.global.x - this.slideStartX) > this.payTableBarContainer.x)
        gameMainDrawer.betBar.isDraggingEnd = false;
      this.handleProgressMove(event);
    }
  }

  handleProgressMove(event) {
    this.payTableBarContainer.x = event.data.global.x - this.touchStartX;
  }

  setupSliderEventsGraphics() {
    const slideGraphics = PixiBase.createGraphics();
    this.slideGraphics = slideGraphics;
    this.slideStartX = null;
    slideGraphics.beginFill('red');
    slideGraphics.alpha = 0;
    isMobile()
      ? slideGraphics.drawRect(2, 215, 540, 505)
      : slideGraphics.drawRect(-270, 0, 1440, 810);
    slideGraphics.endFill();
    this.payTableContainersWrapper.addChild(this.slideGraphics);
    PixiBase.setupButtonMode(this.slideGraphics, { interactive: true, buttonMode: true });
    PixiBase.registerClick(this.slideGraphics, (event) => {
      if (this.isSlideAnimationOn) return;
      this.isButtonPressed = true;
      gameMainDrawer.betBar.isDragging = true;
      this.touchStartX = event.data.global.x - this.payTableBarContainer.x;
      this.slideStartX = event.data.global.x;
      this.slideGraphics.interactive = true;
    });
    PixiBase.registerPointerMove(this.slideGraphics, (event) => {
      if (this.isSlideAnimationOn) return;
      this.onHandleDragMove(event);
    });
    PixiBase.registerPointerup(this.slideGraphics, (event) => {
      this.handleSwitchSideOnDrag(event);
      this.isButtonPressed = false;
    });
    PixiBase.registerPointerUpOutside(this.slideGraphics, (event) => {
      this.handleSwitchSideOnDrag(event);
      this.isButtonPressed = false;
    });
  }

  handleSwitchSideOnDrag(event) {
    gameMainDrawer.betBar.isDragging = false;
    this.difference = event.data.global.x - this.slideStartX;
    if (this.difference > 0 && this.isButtonPressed) {
      this.switchPage({ direction: -1 });
    } else if (this.difference < 0 && this.isButtonPressed) {
      this.switchPage({ direction: 1 });
    }
  }

  execute(config, spriteSheet) {
    const [gameImageSpriteSheet] = spriteSheet;
    this.config = config;
    this.spriteSheet = gameImageSpriteSheet;
    const {
      IntroBarContainer: { introBarContainerConfig, payTableBarContainerConfig },
    } = this.config;
    setContainersPosition(this.IntroBarContainer, introBarContainerConfig);
    setContainersPosition(this.payTableBarContainer, payTableBarContainerConfig);
    this.setupSettingsHeader();
    this.setupSoundSettings();
    this.setupSettingsTitle();
    this.setupArrowButtons();
  }
}
